export const iconFontAwesomeEnergyWind = (
	<i className="fa-solid fa-wind"></i>
);
